module.exports = __webpack_public_path__ + "media/country_flags/mn-248a03c4.png";